module.exports = __webpack_public_path__ + "img/status-page-secton-bg.5e159c04.png";